<template>
  <div>
    <div class="col-xs-12 col-sm-6">
      <div class="order-title-area-sty">
        <div class="order-main-title-sty">
          <h3>更新您的專屬推薦電話號碼</h3>
        </div>
      </div>
      <div class="order-contain">
        <div class="order-sub-title-sty">
          <h5>輸入您的號碼已獲得推薦人資格</h5>
        </div>
        <b-form-group
          id="profile-phone"
          label="手機號碼:"
          label-for="phone"
        >
          <b-form-input
            id="phone"
            v-model="phone"
            type="number"
            required
          ></b-form-input>
        </b-form-group>
        <hr>
        <div class="order-footer-contain text-right">
          <b-button
              class="text-white"
              variant="info"
              size="lg"
              @click="checkInputData"
              >送出
          </b-button>
        </div>
      </div>
    </div>
    <div class="order-banner-bottom">
      <img class="order-banner-info" src="@/assets/img/200704.jpg" style="">
    </div>
  </div>
</template>
<script>

export default {
  name: 'UpdateUserInfo',
  props: {
    userId: String,
    userType: String
  },
  data () {
    return {
      phone: null
    }
  },
  created () {
    this.$nextTick(() => {
      this.getCurrentData()
    })
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getCurrentData () {
      const self = this
      const url = this.$apiDoc.customerUrl + this.userId + '/' + this.$apiDoc.apiActionEdit
      var errorMsg = this.$toolDoc.defaultErrorMsg
      var isError = true
      this.$api.get(url, {}).then((resp) => {
        if (resp.result) {
          if (resp.data && resp.data.phone) {
            self.phone = resp.data.phone
            isError = false
          }
        }
        if (isError) {
          errorMsg = resp.data ? resp.data : self.$toolDoc.convertErrorMsg(resp)
          alert(errorMsg)
        }
      }).catch((errorInfo) => {
        console.log('errorInfo:', errorInfo)
        self.setDebugInfo('UpdateUserInfo', errorInfo, true)
        this.$liff.closeWindow()
      })
    },
    checkInputData () {
      if (this.phone) {
        this.submitData()
      } else {
        this.popMsg('您還未輸入電話號碼，請確認輸入後再送出資料', 'danger')
      }
    },
    submitData () {
      const self = this
      const url = this.$apiDoc.customerUrl + this.userId
      var msg = this.$toolDoc.defaultErrorMsg
      var isError = true
      var type = 'danger'
      var opstions = {
        phone: this.phone
      }
      this.$api.patch(url, opstions).then((resp) => {
        if (resp.result) {
          isError = false
          type = 'success'
        }
        if (isError) {
          msg = resp.data ? resp.data : self.$toolDoc.convertErrorMsg(resp)
        } else {
          msg = '已成功更新您的資料'
        }
        self.popMsg(msg, type)
        self.$liff.closeWindow()
      }).catch((errorInfo) => {
        console.log('errorInfo:', errorInfo)
        self.setDebugInfo('UpdateUserInfo', errorInfo, true)
        self.$liff.closeWindow()
      })
    },
    setDebugInfo (type, val, ispop) {
      // const self = this
      const setLogApi = this.$apiDoc.apiSetLog
      const userId = this.$store.getters.getUserId
      var errorMsg = this.$toolDoc.defaultErrorMsg
      var option = {}
      var logMsg = '[Debug][Reception]'
      if (type) {
        logMsg += '[' + type + '][errorInfo]: '
      }
      logMsg += JSON.stringify({ message: val.message, stack: val.stack })
      option.err = logMsg
      option.line_user_id = userId
      this.$api.post(setLogApi, option).then((resp) => {
        if (resp.result) {
          if (ispop) {
            errorMsg = self.$toolDoc.convertErrorMsg(val)
            alert(errorMsg)
          }
        }
      }).catch((errorInfo) => {
        errorMsg += '[errorInfo]:' + JSON.stringify(errorInfo)
        if (ispop) {
          alert(errorMsg)
        } else {
          console.log(errorMsg)
        }
      })
    },
    popMsg (msg, type) {
      if (msg && type) {
        this.$bvToast.toast(msg, {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: type,
          solid: true
        })
      }
    }
  },
  component: {
  }
}
</script>
